import React, { FC, useState } from 'react'
import classNames from 'classnames'

type TextAreaLabelProps = {
  autoComplete?: string
  error?: string
  inputMode?: string
  maxLength?: number
  name: string
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement>
  pattern?: string
  placeholder?: string
  title: string
  value: string | number | ReadonlyArray<string> | undefined
  styleOverride?: string
}

const TextAreaLabel: FC<TextAreaLabelProps> = (props) => {
  const {
    autoComplete,
    error,
    maxLength,
    name,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    placeholder,
    title,
    value,
    styleOverride = '',
  } = props
  const placeholderText = placeholder ?? title

  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = (ev) => {
    setIsFocused(true)
    onFocus?.(ev)
  }

  const handleBlur = (ev) => {
    setIsFocused(false)
    onBlur?.(ev)
  }

  return (
    <div
      data-field={name}
      className={classNames('defaultTextAreaBox', {
        [styleOverride]: styleOverride !== '',
      })}
    >
      <textarea
        autoComplete={autoComplete}
        maxLength={maxLength}
        name={name}
        onBlur={handleBlur}
        onChange={onChange}
        onFocus={handleFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        value={value}
        className={classNames('defaultTextAreaField', {
          defaultTextAreaFieldError: error,
          ['defaultTextAreaFieldNoLabel']: placeholderText === '',
        })}
      />
      {placeholderText !== '' && (
        <label className='defaultTextAreaFieldLabel' htmlFor={name} data-field={name}>
          {isFocused || (typeof value === 'string' && value?.length > 0) ? title : placeholderText}
        </label>
      )}

      {maxLength && (
        <span className='defaultTextAreaCharLimit' data-type='char-limit'>
          {typeof value === 'string' && value?.length
            ? `${Number(maxLength) - value?.length} characters left`
            : `${maxLength} character limit`}
        </span>
      )}

      {error && (
        <span className='defaultInputError' data-type='error'>
          {error}
        </span>
      )}
    </div>
  )
}

export default TextAreaLabel
